export default __webpack_public_path__ + "static/media/lieferheld_background_m1.e22c260f.jpg";